import React, {PropsWithChildren, useState, useCallback} from 'react';
import b_ from 'b_';

import {Button, Icon} from 'client/common/components/lego';

import './info-block.css';

const b = b_.with('info-block');

type InfoBlockProps = PropsWithChildren<{
    className?: string;
    closable?: boolean;
    onClose?: () => void;
}>;

export default function InfoBlock(props: InfoBlockProps) {
    const {className, children, closable = false, onClose} = props;

    const [hidden, setHidden] = useState(false);

    const handleClose = useCallback(() => {
        setHidden(true);

        if (onClose) onClose();
    }, [onClose]);

    return (
        <div className={`${b()} ${className}`} hidden={hidden}>
            <Icon className={b('icon')} type='info' size='m' />
            <div className={b('content')}>
                {children}
            </div>
            {closable && <Button
                size='icon'
                view='clear'
                icon={(cls: string) => <Icon className={cls} type='cross' />}
                onClick={handleClose}
            />}
        </div>
    );
}
